"use client";

import { useEffect, useState } from "react";

export default function CopyrightYear() {
  // Keep prerendering and hydration consistent; refresh after the page mounts.
  const [year, setYear] = useState(2026);
  // The server year must stay stable until hydration completes.
  // eslint-disable-next-line react-hooks/set-state-in-effect
  useEffect(() => setYear(new Date().getFullYear()), []);
  return <>{year}</>;
}
